import React from "react";
import { useTranslation } from "react-i18next";
import SearchTips from "./SearchTips"
import TopicTips from "./TopicTips"
import logoIcon from '../assets/img/logo.svg';
import clearIcon from '../assets/img/icon/close.svg';
import navIcon from '../assets/img/icon/nav.svg';
import {KEYWORDS_URL_QUERY_PARAMETER, RESOURCE_URL_QUERY_PARAMETER, INPUT_FORM_SUBMIT_ACTION} from '../constants/Query'

export default function HomeSearchBar() {
  const { t } = useTranslation();
  const [keywords, setKeywords] = React.useState("")
  const handleChange = (event) =>{
      setKeywords(event.target.value)
  }
  const handleSubmit = (event) => {
      if(!keywords){
          event.preventDefault();
      }
  }
  const handleClear = (event) =>{
      setKeywords('')
  }
  return (
    <main className="search-home-main" role="main">
        <div className="logo center-align">
          <img src={logoIcon} width="325" height="40" alt="Crossmap" />
        </div>
        <div className="search-block">
          <form className="spacing-t-lg por" action={INPUT_FORM_SUBMIT_ACTION} onSubmit={handleSubmit}>
              <input className="input-search lg" name={KEYWORDS_URL_QUERY_PARAMETER} type="search" id="main-search-input" autocomplete="off" placeholder={t('home.search')} value={keywords} onChange={handleChange}/>
              <button className="clear-button" type="button" onClick={handleClear}>
                  <img src={clearIcon} width="12" height="12" alt="" />
              </button>
              {/*<SearchTips input={keywords} from="home"/>*/}
          </form>
        </div>
        {/*<TopicTips />*/}
    </main>
  );
}

export function SearchBar({resource, initQuery}){
  const { t } = useTranslation();
  const [keywords, setKeywords] = React.useState(initQuery)
  const handleChange = (event) =>{
      setKeywords(event.target.value)
  }
  const handleSubmit = (event) => {
      if(!keywords){
          event.preventDefault();
      }
  }
  const handleClear = (event) =>{
      setKeywords('')
  }
  return(
    <div className="topbar-main">
      <button className="nav-toggle flat-button" data-add=".topbar-links">
        <img src={navIcon} width="21" height="17" alt="" />
      </button>
      <div className="logo">
        <a href={`https://${process.env.REACT_APP_CMAP_HOME_DOMAIN}/`}>
          <img src={logoIcon} width="200" height="24" alt="Crossmap" />
        </a>
      </div>
      <div className="search-block header-search-block">
        <form className="por" action={INPUT_FORM_SUBMIT_ACTION} onSubmit={handleSubmit}>
          <input className="input-search" type="search" id="main-search-input" placeholder={t('search_bar.search')} name={KEYWORDS_URL_QUERY_PARAMETER} value={keywords} onChange={handleChange} />
          <input type="hidden" name={RESOURCE_URL_QUERY_PARAMETER} value={resource} />
          <button className="clear-button" type="button" onClick={handleClear}>
            <img src={clearIcon} width="12" height="12" alt="" />
          </button>
          {/*<SearchTips input={keywords} />*/}
        </form>
      </div>
    </div>
  )
}
